/* BNB - Clean & minimal filter sidebar (Oct 2026)        assets/bnb-filters.js
   Loaded only on collection pages. Two small touches on top of the theme's own filters:
   1. Long option lists show the first 6, with a "Show all" / "Show less" link.
   2. The "Out of stock: Show / Hide" choice becomes a single "In stock only" switch.
   3. Clicking a page number or "Next" always brings the shopper back to the top of the products.
   Re-applies automatically when the theme refreshes the filters after a change. */
(function () {
  var LIMIT = 6;

  function enhanceLists(root) {
    root.querySelectorAll('.filter-group').forEach(function (group) {
      var box = group.querySelector('.toggle-target-container');
      if (!box || box.querySelector('.bnb-f-more')) return;
      var items = box.querySelectorAll(':scope > .filter-group__item');
      if (items.length <= LIMIT + 1) return;
      var anyHiddenActive = false;
      items.forEach(function (item, i) {
        if (i >= LIMIT) {
          item.classList.add('bnb-f-extra');
          if (item.querySelector('input:checked')) anyHiddenActive = true;
        }
      });
      if (anyHiddenActive) box.classList.add('bnb-f-open');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bnb-f-more';
      var label = 'Show all ' + items.length;
      btn.textContent = anyHiddenActive ? 'Show less' : label;
      btn.setAttribute('aria-expanded', anyHiddenActive ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = box.classList.toggle('bnb-f-open');
        btn.textContent = open ? 'Show less' : label;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      box.appendChild(btn);
    });
  }

  function enhanceStock(root) {
    var group = root.querySelector('.filter-group--availability');
    if (!group || group.classList.contains('bnb-f-switched')) return;
    var show = group.querySelector('input[type="radio"][value=""]');
    var hide = group.querySelector('input[type="radio"][value="1"]');
    if (!show || !hide) return;
    // A button (not a form input), so it never ends up in the filter URL
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bnb-f-switch';
    btn.setAttribute('role', 'switch');
    btn.innerHTML = '<span>In stock only</span><span class="bnb-f-track" aria-hidden="true"></span>';
    function sync() {
      btn.setAttribute('aria-checked', hide.checked ? 'true' : 'false');
      btn.classList.toggle('is-on', hide.checked);
    }
    sync();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      (hide.checked ? show : hide).click();
      sync();
    });
    group.classList.add('bnb-f-switched');
    group.appendChild(btn);
  }

  function run() {
    var filters = document.querySelector('.template-collection .filters');
    if (!filters) return;
    enhanceLists(filters);
    enhanceStock(filters);
  }

  function start() {
    run();
    // Watch the whole page: the theme swaps the filter panel out after every change
    var target = document.querySelector('main') || document.body;
    if (!target || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(); });
    }).observe(target, { childList: true, subtree: true });
  }

  // Page numbers / Next: the theme loads the next page in place and tries a smooth scroll up,
  // which can get interrupted and leave the shopper at the bottom. Once the new page is in,
  // jump straight to the top of the product area.
  function productsTop() {
    var anchor = document.querySelector('.template-collection [data-ajax-scroll-to]') ||
                 document.querySelector('.template-collection main') || document.body;
    var header = document.querySelector('.section-header');
    var headerH = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
    var y = anchor.getBoundingClientRect().top + window.pageYOffset - headerH - 10;
    return Math.max(0, y);
  }
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('.pagination a');
    if (!link || !document.body.classList.contains('template-collection')) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var loading = document.querySelector('.ajax-loading');
      if (!loading || tries > 40) {
        clearInterval(timer);
        setTimeout(function () { window.scrollTo({ top: productsTop(), behavior: 'auto' }); }, 60);
      }
    }, 100);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
